import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  signal,
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EPastType } from '../../models';

interface ITapOption {
  title: string;
  isSelected: boolean;
  value: EPastType;
}

@Component({
  selector: 'app-h2h-tab-bar',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './h2h-tab-bar.component.html',
  styleUrl: '../../../../../../styles/tab-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class H2hTabBarComponent {
  valueTap = output<EPastType>();
  home = input<string>();
  away = input<string>();

  selectedTap = signal<EPastType>(EPastType.H2H);
  tapOption = computed<ITapOption[]>(() => [
    {
      title: this.translateService.instant('General'),
      isSelected: true,
      value: EPastType.H2H,
    },
    {
      title: `${
        this.home() ?? this.translateService.instant('Home')
      } - ${this.translateService.instant('Home')}`,
      isSelected: false,
      value: EPastType.HOME,
    },
    {
      title: `${
        this.away() ?? this.translateService.instant('Away')
      } - ${this.translateService.instant('Away')}`,
      isSelected: false,
      value: EPastType.AWAY,
    },
  ]);

  displayedTapOptions = computed(() =>
    this.tapOption().map((item) => ({
      ...item,
      isSelected: item.value === this.selectedTap(),
    }))
  );

  constructor(private readonly translateService: TranslateService) {}

  handleSetTap = (value: EPastType) => {
    this.selectedTap.set(value);
    this.valueTap.emit(value);
  };
}
